import { FilterSet, FilterSetService } from './../../../services/filter-set.service';
import { Subscription } from 'rxjs';
import { OverlayService } from './../../../services/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { SapiService } from './../../../services/sapi.service';
import { Router } from '@angular/router';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { Playlist } from '../../../interfaces/playlist';
@Component({
	selector: 'playlist-select',
	templateUrl: './playlist-select.component.html',
	styleUrls: ['./playlist-select.component.scss'],
	providers: [BbTableService, FilterSetService]
})

export class PlaylistSelectComponent implements OnInit, OnDestroy {
	@Input() selectedClips: TableRow[];
	@Output() hidePanel: EventEmitter<any> = new EventEmitter<any>();

	rows: TableRow[] = null;

	protected getRowsSubscription: Subscription;
	protected rowsSelectedSubscription: Subscription;



	constructor(protected bbTableService: BbTableService,
		protected router: Router,
		protected sapiService: SapiService,
		protected translate: TranslateService,
		protected overlayService: OverlayService) { }

	ngOnInit() {
		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(999)
			.sort('title');
		this.bbTableService.setEntity('cliplist').getRows();
		this.getRowsSubscription = this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => this.rows = rows);
	}

	ngOnDestroy() {
		this.getRowsSubscription.unsubscribe();
	}

	addToExistingPlaylist(ev: MouseEvent, row: TableRow) {

		// prevents the standard table actions from occuring
		if (ev) {
			ev.stopPropagation();
			ev.stopImmediatePropagation();
			ev.preventDefault();
			ev.cancelBubble = true;
		}
		this.overlayService.setLoading(true);

		// subscribe to the playlist info
		const playlistObservable = this.sapiService.get('playlist', row.id);
		playlistObservable.subscribe(
			(playlist: Playlist) => {
				// when we have retrieved the information check if it's workable
				if (playlist && this.selectedClips && this.selectedClips.length > 0) {

					// initialize items as array if it has no items
					if (playlist.items === null) {
						playlist.items = [];
					}

					let notInList = true;
					let addCounter = 0;

					// perform checks for every clib that should be added
					this.selectedClips.forEach(clip => {

						notInList = true;

						// check if the item is already in the list
						for (let v = 0; v < playlist.items.length; v++) {
							if (playlist.items[v].id === clip.id) {
								notInList = false;
								break;
							}
						}

						// if not in list add it to the playlist.items
						if (notInList) {
							playlist.items.push(clip.data);
							addCounter++;
						}
					});

					// subscribe to the update of the playlist
					const updateObservable = this.sapiService.update('playlist', playlist);
					updateObservable.subscribe(
						(result: Playlist) => {
							this.overlayService.setLoading(false);

							if (!result) {
								return;
							}

							// display corresponding messages if update was succesfull
							if (addCounter >= 1) {
								this.overlayService.createToast(this.translate.instant('X_MEDIACLIPS_HAVE_BEEN_ADDED_TO_PLAYLIST_Y',
									{ x: addCounter, y: (result.title || result.id) }));
							} else if (addCounter === 0) {
								this.overlayService.createToast(this.translate.instant('NO_MEDIACLIP_WAS_ADDED_TO_PLAYLIST_Y',
									{ y: (result.title || result.id) }));
							} else {
								this.overlayService.createToast(this.translate.instant('MEDIACLIP_HAS_BEEN_ADDED_TO_PLAYLIST_Y',
									{ y: (result.title || result.id) }));
							}

							this.hidePanel.emit(false);
						}
					);
				}
			}
		);
	}

	addToNewPlaylist() {
		// create a filterset to send to the playlist details screen to add the clips to a new static playlist
		const filterSet: FilterSet = [{
			filters: [{
				type: 'mediaclip',
				field: 'id',
				operator: 'is',
				value: []
			}],
		}];

		// add all the clips to the value;
		this.selectedClips.forEach(
			selectedClip => {
				(filterSet[0].filters[0].value as string[]).push(selectedClip.data.id);
			}
		);

		// send as a filterset
		this.router.navigate(['/library/playlist/new_static/general'], { queryParams: { fs: JSON.stringify(filterSet) } });
	}
}
